<template lang="pug">
.main-content
  .form-group
    label.col-md-12 駆動方式
    .col-md-12
      el-input(type='text',value='', v-model='onecupSystemData.drive_method')
  .form-group
    label.col-md-12 駆動モータ
    .col-md-12
      el-input(type='text',value='', v-model='onecupSystemData.moter')
  .form-group
    label.col-md-12 撹拌機
    .col-md-12
      el-input(type='text',value='', v-model='onecupSystemData.mixer')
  .form-group
    label.col-md-12 シリンジ：数量
    .col-md-12
      el-input(type='text',value='', v-model='onecupSystemData.syringe.amount')
  .form-group
    label.col-md-12  シリンジ：容量
    .col-md-12
      el-input(type='text',value='', v-model='onecupSystemData.syringe.volume')
  .form-group
    label.col-md-12  シリンジ：材質
    .col-md-12
      el-input(type='text',value='', v-model='onecupSystemData.syringe.material')
  .form-group
    label.col-md-12 ピストン：ストローク
    .col-md-12
      el-input(type='text',value='', v-model='onecupSystemData.piston.stroke')
  .form-group
    label.col-md-12 ピストン：材質
    .col-md-12
      el-input(type='text',value='', v-model='onecupSystemData.piston.material')
  .form-group
    label.col-md-12 Oリング材質
    .col-md-12
      el-input(type='text',value='', v-model='onecupSystemData.piston.oring')
  .form-group
    label.col-md-12 接続口径：Input
    .col-md-12
      el-input(type='text',value='', v-model='onecupSystemData.connect_caliber.input')
  .form-group
    label.col-md-12 接続口径：Output
    .col-md-12
      el-input(type='text',value='', v-model='onecupSystemData.connect_caliber.output')
  .form-group
    label.col-md-12 バルブ：Output
    .col-md-12
      el-input(type='text',value='', v-model='onecupSystemData.bulb.method')
  .form-group
    label.col-md-12 バルブ：Output
    .col-md-12
      el-input(type='text',value='', v-model='onecupSystemData.bulb.amount')
  .form-group
    label.col-md-12 吐出範囲
    .col-md-12
      el-input(type='text',value='', v-model='onecupSystemData.range')
  .form-group
    label.col-md-12 防爆仕様
    .col-md-12
      el-input(type='text',value='', v-model='onecupSystemData.explosion_proof')
  .form-group
    label.col-md-12 ワンカップ式：カップ容量
    .col-md-12
      el-input(type='text',value='', v-model='onecupSystemData.onecup')
  .form-group
    span.col-md-12 画像:正面図
    el-button(
      type='primary',
      icon='el-icon-plus',
      size='mini',
      @click='onBtnFileAdd("frontImageFileAdd")'
    )
    .col-md-12
      el-table(:data='onecupSystemData.frontImage')
        el-table-column(label='image', width='300')
          template(slot-scope='scope')
            img(:src='scope.row.image', height='128')
        el-table-column(property='name', label='name', width='200')
        el-table-column(label='', width='150')
          template(slot-scope='scope')
            el-button(size='mini', type='danger', icon='el-icon-delete', @click='deleteImage(scope.$index, "frontImage")') 
      input#frontImageFileAdd.hidden(type='file', @change='onFileAdd($event, "frontImage")', accept='image/*')
  .form-group
    span.col-md-12 画像:側面図
    el-button(
      type='primary',
      icon='el-icon-plus',
      size='mini',
      @click='onBtnFileAdd("sideImageFileAdd")'
    )
    .col-md-12
      el-table(:data='onecupSystemData.sideImage')
        el-table-column(label='image', width='300')
          template(slot-scope='scope')
            img(:src='scope.row.image', height='128')
        el-table-column(property='name', label='name', width='200')
        el-table-column(label='', width='150')
          template(slot-scope='scope')
            el-button(size='mini', type='danger', icon='el-icon-delete', @click='deleteImage(scope.$index, "sideImage")') 
      input#sideImageFileAdd.hidden(type='file', @change='onFileAdd($event, "sideImage")', accept='image/*')
  .form-group
    span.col-md-12 画像:上面図
    el-button(
      type='primary',
      icon='el-icon-plus',
      size='mini',
      @click='onBtnFileAdd("topImageFileAdd")'
    )
    .col-md-12
      el-table(:data='onecupSystemData.topImage')
        el-table-column(label='image', width='300')
          template(slot-scope='scope')
            img(:src='scope.row.image', height='128')
        el-table-column(property='name', label='name', width='200')
        el-table-column(label='', width='150')
          template(slot-scope='scope')
            el-button(size='mini', type='danger', icon='el-icon-delete', @click='deleteImage(scope.$index, "topImage")') 
      input#topImageFileAdd.hidden(type='file', @change='onFileAdd($event, "topImage")', accept='image/*')

</template>

<script>
export default {
  name: 'OnecupSystem',
  data () {
    return {
    }
  },
  props: {
    onecupSystemData: Object
  },
  created () {
    if (!this.onecupSystemData.frontImage) {
      this.onecupSystemData.frontImage = []
    }
    if (!this.onecupSystemData.sideImage) {
      this.onecupSystemData.sideImage = []
    }
    if (!this.onecupSystemData.topImage) {
      this.onecupSystemData.topImage = []
    }
  },
  methods: {
    deleteImage (index, imageType) {
      let imageName = ''
      let imageObject
      if (imageType === 'frontImage') {
        imageName = this.onecupSystemData.frontImage[index].name !== undefined ? this.onecupSystemData.frontImage[index].name : '画像'
        imageObject = this.onecupSystemData.frontImage
      } else if (imageType === 'sideImage') {
        imageName = this.onecupSystemData.sideImage[index].name !== undefined ? this.onecupSystemData.sideImage[index].name : '画像'
        imageObject = this.onecupSystemData.sideImage
      } else if (imageType === 'topImage') {
        imageName = this.onecupSystemData.topImage[index].name !== undefined ? this.onecupSystemData.topImage[index].name : '画像'
        imageObject = this.onecupSystemData.topImage
      }
      this.$confirm(imageName + 'を削除しますか？', '', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
        center: true
      }).then(() => {
        imageObject.splice(index, 1)
        this.$message({
          type: 'success',
          message: 'Delete completed'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        })
      })
    },
    onBtnFileAdd (idName) {
      document.getElementById(idName).click()
    },
    onFileAdd (event, objName) {
      let files = event.target.files || event.dataTransfer.files
      if (files[0].type.match(/image/i)) {
        let reader = new FileReader()
        reader.onload = (r) => {
          this.onecupSystemData[objName].splice(0, 1)
          this.onecupSystemData[objName].push({ name: files[0].name, image: r.target.result, caption: '' })
        }
        reader.readAsDataURL(files[0])
      } else {
        let msg = '画像ではありません'
        alert(msg)
      }
    }
  }
}
</script>

<style lang="scss", scoped>
.hidden {
  visibility: hidden;
}

*:focus {
  outline: 0
}
</style>




// WEBPACK FOOTER //
// src/views/components/swan/techInfo/OnecupSystem.vue